<template>
  <DBox
    :id="'cmp-booking-artists-related-contacts'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('related_contact')}`"
    @addClick="addContactRelationClick"
  >
    <!-- <div class="cmp-booking-artists-related-contacts dbox" :v-if="selectedArtistData"> -->
    <NTable
      id="booking-artists-artists_sidewindow-related_contacts"
      class="contact-list h2 p0"
      :headers="headers"
      :items="selectedArtistData.contact_relations"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td
            v-bind="tdcon('contact_name')"
            @click="e => onArtistNameClick(item)"
          >
            <div class="m-link-2">{{ item["contact_name"] }}</div>
          </td>
          <td v-bind="tdcon('contact_type')">
            <span>{{ item["is_company"] === 1 ? $t('company') : $t('person') }}</span>
          </td>
          <td v-bind="tdcon('subject')" class="contact_name">
          <TextField2
              type="text"
              class="dbox1"
              id="relation"
              :showLabel="false"
              :disabled="false"
              :value="item['relation']"
              :bb="'0px'"
              :placeholder="$t('advance_name')"
              @change="(e) => onTextInputChange('relation', e.value, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="relation"
              id="relation"
              placeholder="Description"
              :value="item['relation']"
              v-on:blur="e => onTextInputBlur(e, 'relation', item)"
            /> -->
          </td>
          <td v-bind="tdcon('phone1')">
            <TextField2
              type="text"
              class="dbox1"
              id="phone1"
              :showLabel="false"
              :disabled="false"
              :value="item['phone1']"
              :bb="'0px'"
              :placeholder="$t('phone')"
              @change="(e) => onTextInputChange('phone1', e.value, item)"
            />
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="phone1"
              id="phone1"
              placeholder="Phone"
              :value="item['phone1']"
              v-on:blur="e => onTextInputBlur(e, 'phone1', item)"
            /> -->
          </td>
          <td v-bind="tdcon('main_contact')">
            <div class="checkbox-container">
              <div class="dt-checkbox round v2 s1">
                <input
                  type="checkbox"
                  name="main_contact_id"
                  id="main_contact_id"
                  :checked="
                    item['contact_id'] == selectedArtist['main_contact_id']
                      ? true
                      : false
                  "
                  @click="e => onCheckboxChange(e, 'main_contact_id', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('contract')">
            <div class="checkbox-container">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="contract_flag"
                  id="contract_flag"
                  :checked="item['contract_flag'] == 1 ? true : false"
                  @click="e => onCheckboxChange(e, 'contract_flag', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('rs_travel')">
            <div class="checkbox-container" v-if="item['is_company'] !== 1">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  name="travel_flag"
                  id="travel_flag"
                  :checked="item['travel_flag'] == 1 ? true : false"
                  @click="e => onCheckboxChange(e, 'travel_flag', item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('birthday')">
            <DatePicker2
              v-if="item['is_company'] !== 1"
              id="birthdate"
              :showLabel="false"
              :value="item['birthdate']"
              @input="
                ({ name, value }) =>
                  onTextInputChange(name, value, item)
              "
              bb="none"
            />
                  
            <!-- <TextInput
              v-if="item['is_company'] !== 1"
              type="date"
              :textInputStyle="3"
              :id="'birthdate'"
              :placeholder="'Birthday'"
              :value="item['birthdate']"
              @valuechanged="
                (name, value) => onTextInputChange(name, value, item)
              "
            /> -->
            <!-- <input
              type="text"
              class="ntable--textfield"
              name="birthdate"
              id="birthdate"
              placeholder="Birthday"
              :value="item['birthdate']"
              v-on:blur="e => onTextInputBlur(e, 'birthdate', item)"
            /> -->
          </td>
          <td v-bind="tdcon('passport_no')">
            <TextField2
              v-if="item['is_company'] !== 1"
              type="text"
              class="dbox1"
              id="passport_no"
              :showLabel="false"
              :disabled="false"
              :value="item['passport_no']"
              :bb="'0px'"
              :placeholder="$t('passport_no_string')"
              @change="(e) => onTextInputChange('passport_no', e.value, item)"
            />

            <!-- <input
              v-if="item['is_company'] !== 1"
              type="text"
              class="ntable--textfield"
              name="passport_no"
              id="passport_no"
              placeholder="Passport No"
              :value="item['passport_no']"
              v-on:blur="e => onTextInputBlur(e, 'passport_no', item)"
            /> -->
          </td>
          <td v-bind="tdcon('mail')">
            <img
              v-if="item['email1']"
              src="static/icons/email/email-grey.svg"
              class="dt-icon v5"
              @click="e => onMail(item)"
              :alt="$t('mail_contact')"
              :title="$t('mail_contact')"
            />
          </td>
          <td v-bind="tdcon('close')">
            <img
              src="static/icons/delete.svg"
              class="dt-icon v5"
              @click="e => onDeleteRelatedContact(item)"
              :alt="$t('delete_contact')"
              :title="$t('delete_contact')"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div class="dbox-title-bar--options">
      <img @click="addContactRelationClick" src="static/icons/add-icon.svg" class="dt-icon v4" alt />
    </div>
  </div> -->
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace
} from "../../../store";
import * as ActionTypes from "../../../store/artists/types";

import { mapGetters, mapActions } from "vuex";

import Dropdown from "../../../../../plugins/dropdown/dropdown";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../../plugins/datatable";
import TextInput from "../../../../../plugins/text-field/text-input";
import { contactListLDTRoutes } from "../../../../contacts/router/routes";

export default {
  components: {
    DBox,
    NTable,
    TextInput
  },
  props: {
    layoutItem: {
      type: Object
    },
    selectedArtist: {
      type: Object,
      require: true
    },
    selectedArtistData: {
      type: Object,
      require: true
    },
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 2,
        fullHeight: true,
        footer: false
      })
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      // selectedArtist: "selectedArtist",
      // selectedArtistData: "selectedArtistData"
    }),
    headers: function() {
      return [
        createTableHeader("contact_name", { text: false }), //
        createTableHeader("contact_type", { ta: "left", text: "type" }),
        createTableHeader("subject"),
        createTableHeader("phone1"),
        createTableHeader("main_contact", { ta: "center" }),
        createTableHeader("contract", { ta: "center" }),
        createTableHeader("rs_travel", { ta: "center" }),
        createTableHeader("birthday"),
        createTableHeader("passport_no"),
        createTableHeader("mail", { text: false, mw: 30 }),
        createTableHeader("close", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]:
        ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE,
      [ActionTypes.RELATED_CONTACTS.DELETE.SINGLE]:
        ActionTypes.RELATED_CONTACTS.DELETE.SINGLE,
      [ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE]:
        ActionTypes.SELECTED_ARTIST.UPDATE.SINGLE,
      [ActionTypes.ArtistDetails.UPDATE.SINGLE]:
        ActionTypes.ArtistDetails.UPDATE.SINGLE
    }),
    onTextInputBlur: function(event, name, item) {
      const value = event.target.value;
      this[ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]({ selectedArtistData: this.selectedArtistData, item, name, value });
    },
    onTextInputChange: function(name, value, item) {
      this[ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]({ selectedArtistData: this.selectedArtistData, item, name, value });
    },
    onCheckboxChange: function(event, name, item) {
      const checked = event.target.checked;
      const value = checked === true ? "1" : "0";

      if (name === "main_contact_id") {
        this[ActionTypes.ArtistDetails.UPDATE.SINGLE]({
          item: this.selectedArtist,
          name,
          value: item.contact_id
        });
      } else {
        this[ActionTypes.RELATED_CONTACTS.UPDATE.SINGLE]({ selectedArtistData: this.selectedArtistData, item, name, value });
      }
    },
    onArtistNameClick: function(artist) {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: artist.contact_id,
          tab: "overview"
        }
      });

      // this.$emit(
      //   "artist_calendar_date_selected",
      //   artist.calendar_date_artist_id
      // );
    },
    addArtistClick: function() {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_artist" }
      });
    },
    onMail: function(contact) {
      location.href = `mailto: ${contact.email1}`;
    },
    addContactRelationClick: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.selectedArtist.artist_id,
          external_table: "artists"
        }
      });
    },
    onDeleteRelatedContact: function(contact) {
      this[ActionTypes.RELATED_CONTACTS.DELETE.SINGLE]({
        contactRelationId: contact.contact_relation_id,
        selectedArtistData: this.selectedArtistData
      });
    }

    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-artists-related-contacts {
  .dt-ntable {
    /* th:nth-child(4),
    th:nth-child(5),
    th:nth-child(6) {
      span {
        text-align: center !important;
      }
    }

    th:nth-child(9),
    td:nth-child(9),
    th:nth-child(10),
    td:nth-child(10) {
      max-width: 30px;
      padding: 0px;
      img {
        width:  26px;
        height: 26px;
      }
    }
    
    td{
      padding-right: 10px;
      padding-left: 10px;
    }

    .ntable--textfield {
      padding-left: 0;
    }

    .checkbox-container {
      max-width: 20px;
      margin: auto;
      .checkmark {
        margin-top: 0;
      }
    } */
  }
}
/* @-moz-document url-prefix() { 
  .cmp-booking-artists-related-contacts {
    .dt-ntable {
      th:nth-child(8) {
        span {
          padding-left: 10px;
        }
      }
      td{
        &.passport_no {
           padding-left: 19px;
        }
      }
    }
  }
} */
</style>
